export default "__VITE_ASSET__CtSi9_pO__"